import { createContext, ReactNode, useContext } from "react";

export interface WidgetConfig {
  practiceId: string;
  chainId: string;
  locale: "de" | "en" | "tr" | "cs" | "ru" | "hr" | "es" | "fr" | "it" | "sq";
  logoUrl?: string;
  isWidget: boolean;
  onClose?: () => void;
  /** Distance in pixels from the bottom of the viewport. Defaults to 90. */
  bottomOffset?: number;
  /** Height of the widget in pixels. Defaults to 800. */
  height?: number;
}

const defaultConfig: WidgetConfig = {
  practiceId: "",
  chainId: "",
  locale: "de",
  isWidget: false,
};

const WidgetContext = createContext<WidgetConfig>(defaultConfig);

export const useWidgetConfig = () => useContext(WidgetContext);

export const WidgetConfigProvider = ({
  children,
  config,
}: {
  children: ReactNode;
  config: WidgetConfig;
}) => {
  return (
    <WidgetContext.Provider value={config}>{children}</WidgetContext.Provider>
  );
};
